import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogHeading,
  AlertDialogOverlay,
  Button,
  Checkbox,
  Paragraph,
  VStack,
  message,
  useDisclosure
} from '@payflip/ui/v2';
import { useRef, useState } from 'react';

type Props = {
  loading: boolean;
  onStop: () => void;
};

export function ImpersonateDangerModal({
  onStop,
  loading
}: Props): JSX.Element {
  const [hasAcknowledged, setHasAcknowledged] = useState(false);
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogHeading>
              {message(undefined, 'Employee not onboarded')}
            </AlertDialogHeading>
          </AlertDialogHeader>
          <AlertDialogBody>
            <VStack spacing={4} align="flex-start">
              <Paragraph>
                {message(
                  undefined,
                  "You're about to impersonate an employee who hasn't completed their onboarding."
                )}
              </Paragraph>
              <Paragraph>
                {message(
                  undefined,
                  "This means that they have not accept Payflip's <b>terms and conditions</b> or <b>privacy policy!</b>"
                )}
              </Paragraph>

              <Checkbox
                size="lg"
                isRequired
                isChecked={hasAcknowledged}
                onChange={(e) => setHasAcknowledged(e.currentTarget.checked)}
              >
                <Paragraph pl="space_unit.x1">
                  {message(
                    undefined,
                    'By proceeding, you acknowledge the <b>legal consequences</b> of any actions you might take during this impersonation.'
                  )}
                </Paragraph>
              </Checkbox>
            </VStack>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button isLoading={loading} variant="secondary" onClick={onStop}>
              {message(undefined, 'Stop')}
            </Button>
            <Button isDisabled={!hasAcknowledged} onClick={onClose}>
              {message(undefined, 'Impersonate anyway')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
